<bic-popup (close)="close()" [hasBackdrop]="true" [title]="'Projekte zuordnen – ' + data.site.displayName" customClass="w-[560px] h-fit">
  <div bicPopupContent class="flex flex-col gap-4">
    <span class="text-sm text-gray-500">
      Nur in den ausgewählten Projekten können Nutzer Ordner aus der Site „{{ data.site.displayName }}“ verknüpfen.
      Andere Projekte sehen die Site nicht.
    </span>
    <bic-input [placeholder]="'Projekt suchen …'" [value]="search" (valueChange)="onSearch($event)" [showX]="true"></bic-input>
    <div class="flex flex-col gap-3 max-h-[360px] overflow-y-auto">
      @if (loading) {
        <span class="text-sm text-gray-500">Wird geladen …</span>
      } @else {
        @for (project of filteredProjects; track project.id) {
          <label class="flex flex-row items-center gap-3 cursor-pointer">
            <input type="checkbox" class="w-4 h-4 !text-green bg-gray-50 rounded focus:ring-[none] border border-gray-300"
                   [checked]="selected.has(project.id!)" (change)="toggle(project)">
            <span class="text-sm text-gray-900">{{ project.name }}</span>
          </label>
        } @empty {
          <span class="text-sm text-gray-500">{{ projects.length ? 'Kein Projekt passt zur Suche.' : 'Die Organisation hat noch keine Projekte.' }}</span>
        }
      }
    </div>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button buttonType="white" (onClick)="close()">Abbrechen</bic-button>
    <bic-button [loading]="busy" [disabled]="busy || loading" (onClick)="save()">Zuordnung speichern</bic-button>
  </div>
</bic-popup>
